import "./App.css";
import React, { useState,useEffect } from "react";

import Loader from "./Loader";

export default function RefCode() {
  
  

  const [loading,setLoading] = useState(false);
  const [activeToken, setActiveToken] = useState('');

  const [error,setError] = useState("");
  


  const checkReferralCode = async () => {
    if(refcode != ''){
    setLoading(true);
    const url = global.getBaseUrl()+"/team/check-referral-code";
  
    const body = new URLSearchParams();
    body.append('referral_code', refcode);
  
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body.toString(),
      });
  
      if (!response.ok) {
        setLoading(false);
        setError('Unable to validate at the moment.');
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
  
      const data = await response.json();
      setLoading(false);
      if(data.valid == true){
        registerToken();
      }else{
        setError('Invalid Code. Please try again.');
      }
      return data;
    } catch (error) {
        setLoading(false);
      console.error('Error:', error);
      setError('Unable to validate at the moment.');
      throw error;
    }
}
  };


  const registerToken  = async () => {

    if(refcode != ''){
        console.log('register called '+ activeToken);
        setLoading(true);
        const url = global.getBaseUrl()+"/team/register";
      
        const body = new URLSearchParams();
        body.append('referral_code', refcode);
      
        try {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Token ' + activeToken,
            },
            body: body.toString(),
          });
      
          if (!response.ok) {
            setLoading(false);
            setError('Unable to register at the moment, please try again later');
            throw new Error(`Error: ${response.status} ${response.statusText}`);
          }
      
          const data = await response.json();
          console.log(data);
          setLoading(false);
          global.signInNow();

          return data;
        } catch (error) {
            setLoading(false);
          console.error('Error:', error);
          setError('Unable to validate at the moment, plese try again later');
          throw error;
        }
    }

  }

  useEffect(() => {
    if (localStorage.getItem("USERDATA")) {
      var dd = localStorage.getItem("USERDATA");
      dd = JSON.parse(dd);
      setActiveToken(dd.token);
    }
  }, []);

  const [refcode, setRefCode] = useState("");


  
  return (
    <>
      <div
        className="section"
        style={{
          justifyContent: "center",
        }}
      >
          <Loader loading={loading}></Loader>
        <img
          alt=""
          src={require("./assets/logo.png")}
          style={{
            width: "70%",
          }}
        ></img>
        <br />
        <br />
        <div
          className="row"
          style={{
            width: "90%",
          }}
        >
          <div
            className="col-sm-12"
            style={{
              paddingLeft: 10,
              paddingRight: 10,
            }}
          >
            <div
              className="subHeading"
              style={{
                textAlign: "center",
              }}
            >
              Please enter referral/invitation code to proceed to your account.
            </div>
            <br />
            {error && error != '' && (
              <p style={{ color: "red" }}>
                <div className="badge bg-danger">{error}</div>
              </p>
            )}
            <input
              type="text"
              className="input"
              placeholder="Enter Code"
              onChange={(e) => setRefCode(e.target.value)}
              value={refcode}
            />
            <br />
            <br />

            <button
              className="btn btn-sm btn-success gradColor"
              onClick={() => {
                checkReferralCode();
              }}
            >
              Confirm Code
            </button>
            <br />
            <br />
          
          </div>
        </div>
      </div>
    </>
  );
}
